'use client'
import { CardText } from '@morpho-org/ui-v6/server'
import { motion } from 'motion/react'
import { memo } from 'react'

export interface CardDashboardErrorProps {
  message: string
}

const CardDashboardError = ({ message }: CardDashboardErrorProps) => {
  return (
    <div className="gap-xs flex flex-[1px] items-center justify-center">
      <motion.div
        layout
        key="card-net-apy-error"
        animate={{
          height: '100%'
        }}
        transition={{ duration: 0.2 }}
        style={{
          width: '100%',
          height: '100%'
        }}
      >
        <CardText width="100%" height="100%" text={message} />
      </motion.div>
    </div>
  )
}

export default memo(CardDashboardError)
